import React from 'react';
import './DeleteConfirmModal.css';

function DeleteConfirmModal({ title, message, onConfirm, onCancel, isDeleting }) {
  return (
    <div className="delete-modal-overlay" onClick={onCancel}>
      <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
        <div className="delete-modal-icon">⚠️</div>
        <h3 className="delete-modal-title">{title}</h3>
        <p className="delete-modal-message">{message}</p>
        <p className="delete-modal-warning">
          ⚠️ هذا الإجراء لا يمكن التراجع عنه
        </p>
        <div className="delete-modal-actions">
          <button 
            className="delete-modal-cancel" 
            onClick={onCancel}
            disabled={isDeleting}
          >
            ❌ إلغاء
          </button>
          <button 
            className="delete-modal-confirm" 
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? '⏳ جاري الحذف...' : '🗑️ حذف نهائياً'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmModal;
